import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Lista de Conciliação Bancária
    {
        path: '/prestacao-contas/conciliacao-bancaria',
        name: 'listaConciliacaoBancaria',
        component: () => import('@/modules/prestacaoContas/views/listas/ConciliacaoBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },

    // Lista de Rendimentos de Conta Bancária
    {
        path: '/prestacao-contas/rendimentos-conta-bancaria',
        name: 'listaRendimentosContaBancaria',
        component: () => import('@/modules/prestacaoContas/views/listas/RendimentosContaBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },

    // Gerencial
    {
        path: '/prestacao-contas/gerencial',
        name: 'gerencialPrestacaoContas',
        component: () => import('@/modules/prestacaoContas/views/gerencial/GerencialView.vue'),
        meta: {
            requiresAuth: true,
            temFilhas: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
        redirect: { name: 'gerencialAtualizacoes' },
        children: [
            {
                path: '/prestacao-contas/gerencial/atualizacoes',
                name: 'gerencialAtualizacoes',
                component: () => import('@/modules/prestacaoContas/components/gerencial/AtualizacoesTab.vue'),
            },
            {
                path: '/prestacao-contas/gerencial/a-concluir',
                name: 'gerencialAConcluir',
                component: () => import('@/modules/prestacaoContas/components/gerencial/VigenciaTab.vue'),
                props: { tipo: 'aConcluir' },
            },
            {
                path: '/prestacao-contas/gerencial/concluidos',
                name: 'gerencialConcluidos',
                component: () => import('@/modules/prestacaoContas/components/gerencial/VigenciaTab.vue'),
                props: { tipo: 'concluidos' },
            },
            {
                path: '/prestacao-contas/gerencial/prestacoes',
                name: 'gerencialEnvios',
                component: () => import('@/modules/prestacaoContas/components/gerencial/EnviosTab.vue'),
            },
        ],
    },

    // Lista de Balancetes
    {
        path: '/prestacao-contas/balancetes',
        name: 'listaBalancetes',
        component: () => import('@/modules/prestacaoContas/views/listas/BalancetesView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },

    // Balancete Detalhado
    {
        path: '/prestacao-contas/balancetes/:projetoId/detalhado',
        name: 'balanceteDetalhado',
        component: () => import('@/modules/prestacaoContas/views/listas/BalanceteDetalhadoView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },

    // Cadastro de Rendimento de Conta Bancária
    {
        path: '/prestacao-contas/rendimentos-conta-bancaria/cadastrar',
        name: 'cadastroRendimentoContaBancaria',
        component: () => import('@/modules/prestacaoContas/views/cadastros/CadastroRendimentoContaBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },

    // Edição de Rendimento de Conta Bancária
    {
        path: '/prestacao-contas/rendimentos-conta-bancaria/:id/editar',
        name: 'edicaoRendimentoContaBancaria',
        component: () => import('@/modules/prestacaoContas/views/cadastros/CadastroRendimentoContaBancariaView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'PROJETO')],
        },
    },
];
